/* Climb Culture events calendar. Spec v1.2 */
(function () {
function initCalendar(root) {
  if (!root || root.dataset.ccReady) return;
  root.dataset.ccReady = '1';

  var STATES = ['All', 'QLD', 'NSW', 'ACT', 'VIC', 'TAS', 'SA', 'WA', 'NT'];
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var ML = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var events = [];

  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return []; } }
  function pad(n) { return String(n).padStart(2, '0'); }
  function pd(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function tm(hm) {
    if (!hm) return '';
    var p = hm.split(':').map(Number), h = p[0], m = p[1];
    return (((h + 11) % 12) + 1) + (m ? ':' + pad(m) : '') + (h >= 12 ? 'pm' : 'am');
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function safeUrl(u) { return /^https?:\/\//i.test(u || '') ? u : '#'; }

  var now = new Date();
  var todayKey = key(now);
  var params = new URLSearchParams(window.location.search);
  var monthParam = /^\d{4}-\d{2}$/.test(params.get('month') || '') ? params.get('month') : null;
  var stateParam = (params.get('state') || 'All').split(',').filter(function (s) { return s === 'National' || STATES.indexOf(s) > -1; });
  var st = {
    states: stateParam.length && stateParam[0] !== 'All' ? stateParam : [],
    y: monthParam ? +monthParam.slice(0, 4) : now.getFullYear(),
    m: monthParam ? +monthParam.slice(5, 7) - 1 : now.getMonth(),
    type: params.get('type') || 'All',
    disc: params.get('discipline') || 'All',
    free: params.get('free') === '1',
    beginner: params.get('beginner') === '1',
    view: params.get('view') === 'calendar' ? 'cal' : 'list'
  };

  var q = function (s) { return root.querySelector(s); };
  var typeSel = q('[data-cc-type]'), discSel = q('[data-cc-disc]');
  var freeBox = q('[data-cc-free]'), begBox = q('[data-cc-beginner]');
  var out = q('[data-cc-out]');

  function syncUrl() {
    var p = new URLSearchParams(window.location.search);
    function setOrDel(k, v, def) { if (v === def || v === '' || v == null) p.delete(k); else p.set(k, v); }
    setOrDel('state', st.states.join(','), '');
    setOrDel('month', st.y + '-' + pad(st.m + 1), now.getFullYear() + '-' + pad(now.getMonth() + 1));
    setOrDel('type', st.type, 'All');
    setOrDel('discipline', st.disc, 'All');
    setOrDel('free', st.free ? '1' : '', '');
    setOrDel('beginner', st.beginner ? '1' : '', '');
    setOrDel('view', st.view === 'cal' ? 'calendar' : '', '');
    var qs = p.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  }

  function renderStates() {
    var wrap = q('[data-cc-states]');
    wrap.textContent = '';
    STATES.forEach(function (s) {
      var b = el('button', 'cc-cal__pill', s === 'All' ? 'All states' : s);
      b.type = 'button';
      var on = s === 'All' ? st.states.length === 0 : st.states.length === 1 && st.states[0] === s;
      if (s !== 'All' && st.states.length > 1 && st.states.indexOf(s) > -1) on = true;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.addEventListener('click', function () { st.states = s === 'All' ? [] : [s]; render(); });
      wrap.appendChild(b);
    });
  }

  function matches(e) {
    return (st.states.length === 0 || st.states.indexOf(e.s) > -1) &&
      (st.type === 'All' || e.ty === st.type) &&
      (st.disc === 'All' || (e.di || []).indexOf(st.disc) > -1) &&
      (!st.free || e.f) && (!st.beginner || e.b);
  }

  function whenText(e) {
    var d = pd(e.d), s = WD[d.getDay()] + ' ' + d.getDate() + ' ' + MS[d.getMonth()];
    if (e.e) { var d2 = pd(e.e); s += ' to ' + WD[d2.getDay()] + ' ' + d2.getDate() + ' ' + MS[d2.getMonth()]; }
    if (e.st) s += ', ' + tm(e.st) + (e.et ? ' to ' + tm(e.et) : '');
    return s;
  }

  function card(e) {
    var a = el('article', 'cc-cal__card');
    var main = el('div', 'cc-cal__card-main');
    var chips = el('div', 'cc-cal__chips');
    chips.appendChild(el('span', 'cc-cal__chip cc-cal__chip--type', e.ty));
    if (e.di && e.di.length) chips.appendChild(el('span', 'cc-cal__chip', e.di.join(' · ')));
    if (e.se) chips.appendChild(el('span', 'cc-cal__chip', e.se));
    if (e.f) chips.appendChild(el('span', 'cc-cal__chip cc-cal__chip--wash', 'Free'));
    if (e.b) chips.appendChild(el('span', 'cc-cal__chip cc-cal__chip--wash', 'Beginner friendly'));
    main.appendChild(chips);
    main.appendChild(el('h3', 'cc-cal__card-title', e.t));
    var where = [e.v, e.sub].filter(Boolean).join(', ') + ' ' + e.s;
    main.appendChild(el('p', 'cc-cal__meta', whenText(e) + ' · ' + where));
    var cost = e.f ? 'Free' : e.c;
    main.appendChild(el('p', 'cc-cal__host', 'Hosted by ' + (e.host || 'TBC') + (cost ? ' · ' + cost : '')));
    a.appendChild(main);
    var link = el('a', 'cc-cal__btn', 'View details');
    link.href = safeUrl(e.u);
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('aria-label', 'View details for ' + e.t + ' (opens in a new tab)');
    a.appendChild(link);
    return a;
  }

  function render() {
    var monthStart = new Date(st.y, st.m, 1), monthEnd = new Date(st.y, st.m + 1, 0);
    var msKey = key(monthStart), meKey = key(monthEnd);
    var list = events.filter(function (e) {
      var last = e.e || e.d;
      return e.d <= meKey && last >= msKey && last >= todayKey && matches(e);
    }).sort(function (a, b) { return (a.d + (a.st || '')).localeCompare(b.d + (b.st || '')); });

    renderStates();
    typeSel.value = st.type; discSel.value = st.disc;
    freeBox.checked = st.free; begBox.checked = st.beginner;
    root.querySelectorAll('[data-cc-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', (b.dataset.ccView === st.view) ? 'true' : 'false');
    });
    q('[data-cc-month]').textContent = ML[st.m] + ' ' + st.y;
    var where = st.states.length === 0 ? ' across Australia' : ' in ' + st.states.join(', ');
    q('[data-cc-count]').textContent = list.length + (list.length === 1 ? ' event' : ' events') + where;

    out.textContent = '';
    if (st.view === 'list') {
      var wrap = el('div', 'cc-cal__list');
      var groups = {};
      var order = [];
      list.forEach(function (e) {
        var k = e.d < todayKey ? todayKey : e.d;
        if (!groups[k]) { groups[k] = []; order.push(k); }
        groups[k].push(e);
      });
      order.forEach(function (k) {
        var d = pd(k);
        var day = el('div', 'cc-cal__day');
        var date = el('div', 'cc-cal__date');
        date.appendChild(el('div', 'cc-cal__date-wd', WD[d.getDay()]));
        date.appendChild(el('div', 'cc-cal__date-num', String(d.getDate())));
        date.appendChild(el('div', 'cc-cal__date-mon', MS[d.getMonth()]));
        day.appendChild(date);
        var evs = el('div', 'cc-cal__events');
        groups[k].forEach(function (e) { evs.appendChild(card(e)); });
        day.appendChild(evs);
        wrap.appendChild(day);
      });
      if (!list.length) {
        var empty = el('div', 'cc-cal__empty');
        empty.appendChild(el('p', null, 'Nothing matches those filters this month.'));
        var reset = el('button', 'cc-cal__pill', 'Clear filters');
        reset.type = 'button';
        reset.addEventListener('click', function () { st.states = []; st.type = 'All'; st.disc = 'All'; st.free = false; st.beginner = false; render(); });
        empty.appendChild(reset);
        wrap.appendChild(empty);
      }
      out.appendChild(wrap);
    } else {
      var scroll = el('div', 'cc-cal__grid-scroll');
      var grid = el('div', 'cc-cal__grid');
      ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].forEach(function (w) { grid.appendChild(el('div', 'cc-cal__wdh', w)); });
      var offset = (monthStart.getDay() + 6) % 7;
      var weeks = Math.ceil((offset + monthEnd.getDate()) / 7);
      for (var i = 0; i < weeks * 7; i++) {
        var d = new Date(st.y, st.m, 1 - offset + i), k = key(d);
        var cell = el('div', 'cc-cal__cell' + (d.getMonth() !== st.m ? ' cc-cal__cell--out' : '') + (k === todayKey ? ' cc-cal__cell--today' : ''));
        cell.appendChild(el('span', 'cc-cal__cell-num', String(d.getDate())));
        var evs2 = list.filter(function (e) { return k >= e.d && k <= (e.e || e.d); });
        evs2.slice(0, 2).forEach(function (e) {
          var a = el('a', 'cc-cal__pillev');
          a.href = safeUrl(e.u); a.target = '_blank'; a.rel = 'noopener';
          var b = el('strong', null, (e.st ? tm(e.st) + ' ' : '') + e.s);
          a.appendChild(b);
          a.appendChild(document.createTextNode(' ' + e.t));
          cell.appendChild(a);
        });
        if (evs2.length > 2) {
          var more = el('button', 'cc-cal__more', '+' + (evs2.length - 2) + ' more');
          more.type = 'button';
          more.addEventListener('click', function () { st.view = 'list'; render(); });
          cell.appendChild(more);
        }
        grid.appendChild(cell);
      }
      scroll.appendChild(grid);
      out.appendChild(scroll);
    }
    syncUrl();
  }

  typeSel.addEventListener('change', function () { st.type = typeSel.value; render(); });
  discSel.addEventListener('change', function () { st.disc = discSel.value; render(); });
  freeBox.addEventListener('change', function () { st.free = freeBox.checked; render(); });
  begBox.addEventListener('change', function () { st.beginner = begBox.checked; render(); });
  root.querySelectorAll('[data-cc-view]').forEach(function (b) {
    b.addEventListener('click', function () { st.view = b.dataset.ccView; render(); });
  });
  q('[data-cc-prev]').addEventListener('click', function () { if (st.m === 0) { st.m = 11; st.y--; } else st.m--; render(); });
  q('[data-cc-next]').addEventListener('click', function () { if (st.m === 11) { st.m = 0; st.y++; } else st.m++; render(); });

  var dataEl = root.querySelector('[data-cc-events]');
  events = readJSON(dataEl);
  render();

  // Over 250 events: fetch further pages through the Section Rendering API, then re-render.
  function loadMore(page) {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(root.dataset.sectionId) + '&page=' + page;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var more = doc.querySelector('[data-cc-events]');
      if (!more) return;
      events = events.concat(readJSON(more));
      render();
      if (more.dataset.ccNextPage) loadMore(more.dataset.ccNextPage);
    }).catch(function () {});
  }
  if (dataEl && dataEl.dataset.ccNextPage) loadMore(dataEl.dataset.ccNextPage);
}
function boot() { document.querySelectorAll('.cc-cal[data-section-id]').forEach(initCalendar); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();